module.exports = __webpack_public_path__ + "img/sdsl.f59495b6.png";